import PropTypes from 'prop-types';
import React from 'react';
import { injectIntl } from 'react-intl';
import { compose } from 'redux';
import { Field, reduxForm } from 'redux-form';
import { fieldRequired, requiredInput, Select } from '../../../core/formValidation';
import { Row, Col } from 'reactstrap';
import { washSelection, detergentSelection, colorSelect, inventorySelection } from '../helpers';

const DetergentEditForm = ({
  products,
  intl,
  inventory,
  selectedProducts,
  handleProductChange,
  handleDetergentChange,
  selectedDetergent,
  detergents,
  handleInventoryChange,
  selectedInventory,
  handleSelectAllProducts,
}) => {
  return (
    <div>
      <div>
        <Row>
          <Col>
            <label className="custom-modal-title">
              {intl.formatMessage({ id: 'editDetergentsDetails' })}
            </label>

            <div className="form-group">
              <Field
                className="form-control"
                name="name"
                id="name"
                component={() =>
                  detergentSelection({
                    detergents,
                    intl,
                    handleDetergentChange,
                    initialValues: selectedDetergent,
                  })
                }
                type="text"
                aria-describedby="descriptionHelp"
                placeholder="Enter name for detergent"
                validate={[fieldRequired]}
              />
            </div>
          </Col>
        </Row>
        <Row>
          <Col>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <label htmlFor="capacity">{intl.formatMessage({ id: 'washPlanProducts' })}</label>
              {handleSelectAllProducts && products && products.length > 0 && (
                <button
                  type="button"
                  onClick={handleSelectAllProducts}
                  style={{
                    background: 'none',
                    border: 'none',
                    color: '#007bff',
                    cursor: 'pointer',
                    textDecoration: 'underline',
                    fontSize: '14px',
                    padding: 0,
                  }}
                >
                  {intl.formatMessage({ id: 'selectAll' }, { defaultMessage: 'Select All' })}
                </button>
              )}
            </div>
            <div className="form-group">
              <Field
                name="detergentWashes"
                component={() =>
                  washSelection({
                    products,
                    intl,
                    selectedProducts,
                    handleProductChange,
                  })
                }
              />
            </div>
          </Col>
          <Col>
            <label htmlFor="capacity">{intl.formatMessage({ id: 'capacityGal' })}</label>
            <div className="form-group">
              <Field
                className="form-control"
                name="capacity"
                id="capacity"
                component={requiredInput}
                type="number"
                step="1"
                aria-describedby="descriptionHelp"
                placeholder="Capacity of the container"
                validate={[fieldRequired]}
              />
            </div>
          </Col>
          <Col>
            <label htmlFor="alarmLevel">{intl.formatMessage({ id: 'alarmGal' })}</label>
            <div className="form-group">
              <Field
                className="form-control"
                name="alarmLevel"
                id="alarmLevel"
                component="input"
                type="number"
                step="1"
                aria-describedby="descriptionHelp"
                placeholder="Alarm level"
              />
            </div>
          </Col>
        </Row>
        <Row>
          <Col>
            <label htmlFor="inventoryItem">
              {intl.formatMessage({ id: 'relatedInventoryItem' })}
            </label>
            <div className="form-group">
              <Field
                name="inventoryItem"
                id="inventoryItem"
                component={() =>
                  inventorySelection({
                    inventory,
                    intl,
                    handleInventoryChange,
                    selectedInventory,
                  })
                }
                parse={Number}
              />
            </div>
          </Col>
          <Col>
            <label htmlFor="position">{intl.formatMessage({ id: 'position' })}</label>
            <div className="form-group">
              <Field
                className="form-control"
                name="position"
                id="position"
                component="input"
                type="number"
                parse={(value) => Number(value)}
                aria-describedby="descriptionHelp"
                placeholder="enter"
              />
            </div>
          </Col>
          <Col>
            <label htmlFor="reorderLevel">{intl.formatMessage({ id: 'autoRorderLevel' })}</label>
            <div className="form-group">
              <Field
                className="form-control"
                name="reorderLevel"
                id="reorderLevel"
                component="input"
                type="number"
                step="1"
                aria-describedby="descriptionHelp"
                placeholder="Reorder Level"
              />
            </div>
          </Col>
        </Row>
        <Row>
          <Col>
            <label htmlFor="detergentColor">{intl.formatMessage({ id: 'detergentColor' })}</label>
            <div className="form-group">
              <Field
                className="form-control"
                name="detergentColor"
                id="detergentColor"
                component={colorSelect}
                type="text"
                aria-describedby="descriptionHelp"
                placeholder="detergent Color"
              />
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
};

DetergentEditForm.propTypes = {
  intl: PropTypes.shape({}).isRequired,
  products: PropTypes.arrayOf(PropTypes.shape({})),
  inventory: PropTypes.arrayOf(PropTypes.shape({})),
  selectedProducts: PropTypes.arrayOf(PropTypes.shape({})),
  selectedInventory: PropTypes.shape({}),
  handleInventoryChange: PropTypes.func,
  handleSelectAllProducts: PropTypes.func,
  addNew: PropTypes.bool,
};

// TODO: add validator
const enhance = compose(injectIntl, reduxForm({ form: 'detergent' }));

export default enhance(DetergentEditForm);
